<footer class="footer" style="background-color: #000;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                <p class="mb-0">Copyright {{year}} © TECSA All rights reserved.</p>
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    <p class="pull-right mb-0">Copyright {{year}} © TECSA</p>
                </div>
            </div>
        </div>
    </div>
</footer>